import type { BrandProfile } from './brand'

// Baked by rsbuild from brands.json for VITE_BRAND.
declare const __BRAND__: BrandProfile

// Validated here so a bad define fails at startup.
export function activeBrand(profile: BrandProfile = __BRAND__): BrandProfile {
  for (const field of ['key', 'name', 'operator'] as const) {
    if (typeof profile?.[field] !== 'string' || profile[field].trim() === '') {
      throw new Error(`Brand profile is missing ${field}`)
    }
  }
  return profile
}
